import styled, { css, FlattenSimpleInterpolation } from 'styled-components'
import { GRAY_INFO, PRIMARY_PURPLE, WHITE } from 'constants/colors'
import { ButtonType } from 'components/common/Button/Button.types'
import {
  BUTTON_TYPE_PRIMARY,
  BUTTON_TYPE_SECONDARY,
} from 'components/common/Button/constants'

export const StyledButton = styled.div<{
  type: ButtonType
  customStyles?: FlattenSimpleInterpolation
  disabled?: boolean
}>`
  > button {
    &.MuiButton-root {
      padding: ${({ type }) =>
        type === BUTTON_TYPE_PRIMARY ? '10px 12px' : '8px 12px'};
      border: ${({ type }) =>
        type === BUTTON_TYPE_SECONDARY ? css`1px solid ${GRAY_INFO};` : 'none'};
      background: ${({ type }) =>
        type === BUTTON_TYPE_PRIMARY ? PRIMARY_PURPLE : 'transparent'};
      ${({ type }) =>
        type === BUTTON_TYPE_PRIMARY &&
        css`
          color: ${WHITE};
        `};
      ${({ disabled }) =>
        disabled &&
        css`
          opacity: 0.4;
        `};
      white-space: nowrap;
      text-align: left;
      text-transform: capitalize;
      position: relative;
      border-radius: 8px;
      line-height: 1;
      ${({ customStyles }) =>
        customStyles &&
        css`
          ${customStyles}
        `};
    }

    &:hover {
      background: ${GRAY_INFO};
    }
  }
`
